module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "file_024"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0014-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "file_024"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Outside Grumman’s hangar and shop in Valley Stream, New York, “The Plane” awaits another test flight. After a brief round of testing, the XFF-1 was supplied to the navy for $73,975. "), _c('em', [_vm._v("Grumman History Center")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d3bb18d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_024.vue
// module id = 123
// module chunks = 0